/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIWaste } from './APIWaste';
import {
    APIWasteFromJSON,
    APIWasteFromJSONTyped,
    APIWasteToJSON,
} from './APIWaste';

/**
 * 
 * @export
 * @interface APIPaginatedWasteList
 */
export interface APIPaginatedWasteList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedWasteList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedWasteList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedWasteList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIWaste>}
     * @memberof APIPaginatedWasteList
     */
    results: Array<APIWaste>;
}

/**
 * Check if a given object implements the APIPaginatedWasteList interface.
 */
export function instanceOfAPIPaginatedWasteList(value: object): value is APIPaginatedWasteList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedWasteListFromJSON(json: any): APIPaginatedWasteList {
    return APIPaginatedWasteListFromJSONTyped(json, false);
}

export function APIPaginatedWasteListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedWasteList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIWasteFromJSON)),
    };
}

export function APIPaginatedWasteListToJSON(value?: APIPaginatedWasteList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIWasteToJSON)),
    };
}

